































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import draggable from "vuedraggable";
import {SiteEntity} from "@/entity/SiteEntity";
import {
    isLeaveConfirmed,
    registerUnsavedGuard,
    unregisterUnsavedGuard,
    UnsavedGuard,
} from "@/store";

// Kaydedilmemiş değişiklik varken ekrandan çıkarken sorulsun
Component.registerHooks(["beforeRouteLeave"]);

/** Sunucudaki ekip üyesi (config "teams" bloğu, format 2) */
interface TeamItem {
    name: string;
    title: string;
    /** /images/ altına göre yol: "ekip/1.jpg" ya da "sites/<site_key>/ekip/<dosya>.jpg" */
    image: string;
    active: string;
}

/** Ekrandaki satır */
interface TeamRow extends TeamItem {
    uid: number;
    /** Kaydette yüklenecek yeni fotoğraf (küçültülmüş) */
    file: File | null;
    /** Yeni fotoğrafın önizleme adresi (blob:) */
    preview: string;
    fileError: string;
    processing: boolean;
}

const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
const ALLOWED_EXTS = ["jpg", "jpeg", "png", "webp"];
/*
 * Sunucuda upload_max_filesize 2 MB, post_max_size 8 MB: telefondan çekilen
 * 3–6 MB'lık fotoğraf sessizce düşüyor, birkaç fotoğraf birlikte tüm isteği
 * boşaltıyordu. Fotoğraflar gönderilmeden önce tarayıcıda küçültülür.
 */
const MAX_SIDE = 1200;
const KEEP_AS_IS_BYTES = 1024 * 1024;
const SERVER_FILE_LIMIT = 1.9 * 1024 * 1024;
const REQUEST_LIMIT = 7 * 1024 * 1024;
const MAX_INPUT_BYTES = 30 * 1024 * 1024;

let uidCounter = 0;

function text(value: any): string {
    return value === undefined || value === null ? "" : String(value);
}

function toRow(item: any): TeamRow {
    const source = item && typeof item === "object" ? item : {};
    const active = text(source.active).trim();
    return {
        uid: ++uidCounter,
        name: text(source.name),
        title: text(source.title),
        image: text(source.image).trim(),
        // Eksik alan görünür sayılır (varsayılan liste hepsi görünür)
        active: active === "0" || active === "false" ? "0" : "1",
        file: null,
        preview: "",
        fileError: "",
        processing: false,
    };
}

function loadImage(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Fotoğraf okunamadı; JPG, PNG ya da WEBP bir fotoğraf seçin."));
        };
        img.src = url;
    });
}

function tooBig(): Error {
    return new Error("Fotoğraf çok büyük (en fazla 2 MB). Daha küçük bir fotoğraf seçin.");
}

/** Fotoğrafı en uzun kenarı 1200 px olacak şekilde JPG'ye küçültür; küçükse olduğu gibi bırakır */
async function prepareImage(file: File): Promise<File> {
    const type = text(file.type).toLowerCase();
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    if (ALLOWED_TYPES.indexOf(type) === -1 && !(type === "" && ALLOWED_EXTS.indexOf(ext) !== -1)) {
        throw new Error("Yalnızca JPG, PNG ya da WEBP fotoğraf yüklenebilir.");
    }
    if (file.size > MAX_INPUT_BYTES) {
        throw new Error("Fotoğraf çok büyük; 30 MB'tan küçük bir fotoğraf seçin.");
    }
    const img = await loadImage(file);
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    if (!width || !height) {
        throw new Error("Fotoğraf okunamadı.");
    }
    const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
    if (scale === 1 && file.size <= KEEP_AS_IS_BYTES && ALLOWED_TYPES.indexOf(type) !== -1) {
        return file;
    }
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        if (file.size <= SERVER_FILE_LIMIT) {
            return file;
        }
        throw tooBig();
    }
    // Şeffaf PNG JPG'de siyah zemin olmasın
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.86));
    if (!blob || blob.size > SERVER_FILE_LIMIT) {
        if (file.size <= SERVER_FILE_LIMIT) {
            return file;
        }
        throw tooBig();
    }
    const base = file.name.replace(/\.[^.]*$/, "").trim() || "foto";
    return new File([blob], base + ".jpg", {type: "image/jpeg", lastModified: Date.now()});
}

@Component({
    components: {draggable}
})
export default class Ekip extends Vue {
    rows: TeamRow[] = [];
    source: string = "default";

    /** Listenin ait olduğu şube (yükleme anındaki aktif şube) */
    loadedSiteId: number | null = null;
    /** Yüklemeler üst üste binerse yalnızca en sonuncusu ekrana yazılır */
    loadToken: number = 0;
    loading: boolean = false;
    saving: boolean = false;
    loadError: string = "";
    snapshot: string = "";
    lastSavedAt: string = "";
    result: { ok: boolean; text: string; visible: boolean } | null = null;
    snackbar = {enabled: false, text: "", color: "success"};

    /** Şube seçicinin sorduğu "kaydedilmemiş değişiklik var mı" (reaktif veri değil) */
    unsavedGuard!: UnsavedGuard | null;

    /* ------------------------------------------------------------------
     * Şube
     * ---------------------------------------------------------------- */

    get activeSiteId(): number | null {
        const id = this.$store.getters.activeSiteId;
        return id === null || id === undefined || id === "" ? null : Number(id);
    }

    get formSite(): SiteEntity | null {
        const sites: SiteEntity[] = this.$store.getters.sites || [];
        const id = this.loadedSiteId !== null ? this.loadedSiteId : this.activeSiteId;
        return sites.find((s: SiteEntity) => Number(s.site_id) === Number(id)) || null;
    }

    get branchName(): string {
        return (this.formSite ? this.formSite.name : "") || this.$store.getters.activeSiteName;
    }

    /** Şubenin Ekip sayfası (yerelde yerel şube adresi) */
    get ekipLink(): string {
        const base: string = this.$store.getters.siteUrlFor(this.formSite) || "";
        if (!base) {
            return "";
        }
        const q = base.indexOf("?");
        return q === -1 ? base + "ekip" : base.substring(0, q) + "ekip" + base.substring(q);
    }

    get siteMismatch(): boolean {
        return this.loadedSiteId !== null && this.activeSiteId !== null
            && Number(this.loadedSiteId) !== Number(this.activeSiteId);
    }

    get processing(): boolean {
        return this.rows.some((row: TeamRow) => row.processing);
    }

    get canSave(): boolean {
        return !this.loading && !this.saving && !this.processing && this.loadError === ""
            && this.loadedSiteId !== null && !this.siteMismatch;
    }

    /* ------------------------------------------------------------------
     * Görsel
     * ---------------------------------------------------------------- */

    photoUrl(row: TeamRow): string {
        if (row.preview) {
            return row.preview;
        }
        const image = row.image.trim();
        if (image === "") {
            return "";
        }
        if (/^https?:\/\//i.test(image)) {
            return image;
        }
        // Yol /images/ altına göre saklanır; başta "/" ya da "images/" gelse de doğru adres kurulsun
        const path = image.replace(/^\/+/, "").replace(/^images\//, "");
        return this.$store.getters.imagePath + path;
    }

    fileSizeText(bytes: number): string {
        return bytes >= 1024 * 1024
            ? (bytes / (1024 * 1024)).toFixed(1).replace(".", ",") + " MB"
            : Math.max(1, Math.round(bytes / 1024)) + " KB";
    }

    pickPhoto(row: TeamRow) {
        if (this.saving || row.processing) {
            return;
        }
        const ref: any = this.$refs["file" + row.uid];
        const input: HTMLInputElement | undefined = Array.isArray(ref) ? ref[0] : ref;
        if (input) {
            input.click();
        }
    }

    async onFileChange(row: TeamRow, event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files && input.files.length > 0 ? input.files[0] : null;
        input.value = "";
        if (!file) {
            return;
        }
        row.processing = true;
        row.fileError = "";
        try {
            const prepared = await prepareImage(file);
            this.releasePreview(row);
            row.file = prepared;
            row.preview = URL.createObjectURL(prepared);
        } catch (e) {
            row.fileError = e && e.message ? e.message : "Fotoğraf hazırlanamadı.";
        } finally {
            row.processing = false;
        }
    }

    undoPhoto(row: TeamRow) {
        this.releasePreview(row);
        row.file = null;
        row.fileError = "";
    }

    releasePreview(row: TeamRow) {
        if (row.preview) {
            URL.revokeObjectURL(row.preview);
            row.preview = "";
        }
    }

    releaseAllPreviews() {
        this.rows.forEach((row: TeamRow) => this.releasePreview(row));
    }

    /* ------------------------------------------------------------------
     * Liste işlemleri
     * ---------------------------------------------------------------- */

    addRow() {
        this.rows.push(toRow({name: "", title: "", image: "", active: "1"}));
    }

    removeRow(index: number) {
        const row = this.rows[index];
        if (!row) {
            return;
        }
        // Kayıt yapılmadıkça hiçbir şey silinmez; "Vazgeç" ile geri alınabilir
        this.releasePreview(row);
        this.rows.splice(index, 1);
    }

    move(index: number, delta: number) {
        const target = index + delta;
        if (target < 0 || target >= this.rows.length) {
            return;
        }
        const copy = this.rows.slice();
        const moved = copy.splice(index, 1)[0];
        copy.splice(target, 0, moved);
        this.rows = copy;
    }

    /* ------------------------------------------------------------------
     * Yükle / kaydet
     * ---------------------------------------------------------------- */

    serialize(): string {
        return JSON.stringify(this.rows.map((row: TeamRow) => [
            row.name, row.title, row.image, row.active,
            row.file ? row.file.name + ":" + row.file.size + ":" + row.uid : "",
        ]));
    }

    get dirty(): boolean {
        return this.snapshot !== "" && this.serialize() !== this.snapshot;
    }

    applyResponse(data: any) {
        const items = data && Array.isArray(data.items) ? data.items : null;
        if (items === null) {
            throw new Error("Sunucudan beklenmeyen yanıt geldi.");
        }
        this.releaseAllPreviews();
        this.rows = items.map((item: any) => toRow(item));
        this.source = text(data.source) === "panel" ? "panel" : "default";
        this.snapshot = this.serialize();
    }

    resetForm() {
        this.releaseAllPreviews();
        this.rows = [];
        this.source = "default";
        this.loadedSiteId = null;
        this.snapshot = "";
    }

    async load() {
        const token = ++this.loadToken;
        // İstek X-Site-Id ile bu şubeye gider; liste bu şubeye ait sayılır
        const requestedSiteId = this.activeSiteId;
        this.loading = true;
        this.loadError = "";
        try {
            const response = await this.$http.get("team");
            if (token !== this.loadToken) {
                return; // bu arada şube değişti; daha yeni yükleme geçerli
            }
            const data = response.data;
            if (!data || typeof data !== "object") {
                throw new Error("Sunucudan beklenmeyen yanıt geldi.");
            }
            const servedId = data._site_id !== undefined && data._site_id !== null ? Number(data._site_id)
                : (data.site_id !== undefined && data.site_id !== null ? Number(data.site_id) : requestedSiteId);
            if (requestedSiteId !== null && servedId !== null && servedId !== requestedSiteId) {
                // Sunucu başka şubeyi döndürdü; bu listeyle kayıt yanlış şubeye yazardı
                throw new Error("Sunucu seçili şubeyi tanımadı; üstteki şube seçicisinden şubeyi yeniden seçin.");
            }
            this.applyResponse(data);
            this.loadedSiteId = servedId !== null ? servedId : 0;
        } catch (e) {
            if (token === this.loadToken) {
                this.resetForm();
                this.loadError = this.errorText(e);
            }
        } finally {
            if (token === this.loadToken) {
                this.loading = false;
            }
        }
    }

    async revert() {
        if (this.dirty && !window.confirm("Kaydedilmemiş değişiklikler silinip kayıtlı liste geri yüklensin mi?")) {
            return;
        }
        this.result = null;
        await this.load();
    }

    /** Kaydı engelleyen sorunlar; boşsa kayıt yapılabilir */
    validationError(): string {
        const unnamed = this.rows.findIndex((row: TeamRow) => row.name.trim() === "");
        if (unnamed !== -1) {
            return (unnamed + 1) + ". sıradaki üyenin adını yazın (ya da üyeyi listeden çıkarın).";
        }
        const badFile = this.rows.find((row: TeamRow) => row.fileError !== "");
        if (badFile) {
            return (badFile.name.trim() || "Bir üye") + ": " + badFile.fileError;
        }
        const total = this.rows.reduce((sum: number, row: TeamRow) => sum + (row.file ? row.file.size : 0), 0);
        if (total > REQUEST_LIMIT) {
            return "Seçilen fotoğraflar birlikte çok büyük. Bir kısmını kaydedip kalanları sonra ekleyin.";
        }
        return "";
    }

    async save() {
        if (!this.canSave) {
            return;
        }
        if (this.siteMismatch) {
            this.notify(false, "Aktif şube değişti; liste yeniden yükleniyor. Kontrol edip tekrar kaydedin.");
            await this.load();
            return;
        }
        const problem = this.validationError();
        if (problem !== "") {
            this.notify(false, problem);
            return;
        }
        if (this.rows.length === 0
            && !window.confirm("Listede kimse yok; Ekip sayfasında ekip üyesi görünmeyecek. Kaydedilsin mi?")) {
            return;
        }
        const branch = this.branchName;
        const savingSiteId = this.loadedSiteId;
        // X-Site-Id her istekte o anki aktif şubeden alınır; liste başka şubeye ait ise gönderilmez
        if (this.activeSiteId !== null && Number(this.activeSiteId) !== Number(savingSiteId)) {
            this.notify(false, "Aktif şube değişti; kaydedilmedi.");
            return;
        }

        const sent = this.rows.slice();
        const items: TeamItem[] = sent.map((row: TeamRow) => ({
            name: row.name.trim(),
            title: row.title.trim(),
            // Yeni fotoğraf seçilse de eski yol gönderilir: yükleme reddedilirse üye fotoğrafsız kalmasın
            image: row.image.trim(),
            active: row.active === "1" ? "1" : "0",
        }));
        const payload = new FormData();
        payload.append("items", JSON.stringify(items));
        sent.forEach((row: TeamRow, index: number) => {
            if (row.file) {
                payload.append("photo_" + index, row.file, row.file.name);
            }
        });

        this.saving = true;
        this.result = null;
        try {
            const response = await this.$http.post("team", payload);
            // Yanıttaki sıra gönderilenle aynı; yüklenmeyen fotoğrafı (sunucu dosyayı
            // sessizce düşürdüyse yol değişmez) kullanıcıya söylemek için karşılaştırılır
            const savedItems: any[] = response.data && Array.isArray(response.data.items) ? response.data.items : [];
            const failedPhotos: string[] = [];
            sent.forEach((row: TeamRow, index: number) => {
                if (row.file && savedItems.length === sent.length
                    && text(savedItems[index] && savedItems[index].image).trim() === row.image.trim()) {
                    failedPhotos.push(row.name.trim());
                }
            });
            if (response.data && Array.isArray(response.data.items)) {
                this.applyResponse(response.data);
            } else {
                await this.load();
            }
            this.lastSavedAt = new Date().toLocaleTimeString("tr-TR");
            if (failedPhotos.length > 0) {
                this.notify(false, "Liste kaydedildi ancak şu üyelerin fotoğrafı yüklenemedi: "
                    + failedPhotos.join(", ") + ". Başka bir fotoğrafla tekrar deneyin.");
            } else {
                this.notify(true, "Kaydedildi. Ekip sayfası " + (branch || "bu şubenin") + " sitesinde güncellendi; diğer şube etkilenmedi.");
            }
        } catch (e) {
            // Liste ekranda kalır; tekrar denenebilir
            this.notify(false, "Kaydedilemedi: " + this.errorText(e));
        } finally {
            this.saving = false;
        }
    }

    notify(ok: boolean, message: string) {
        this.result = {ok: ok, text: message, visible: true};
        this.snackbar = {enabled: true, text: message, color: ok ? "success" : "error"};
    }

    errorText(e: any): string {
        let message = "";
        try {
            // Doğrulama hataları {messages:[…]} olarak gelir; errorHandler sonuna " - " ekliyor
            message = String(this.$helper.errorHandler(e) || "").replace(/\s*-\s*$/, "");
        } catch (ignored) {
            message = "";
        }
        if (!message && e && e.response) {
            message = e.response.status === 413
                ? "Fotoğraflar sunucu için çok büyük."
                : "Sunucu hatası (HTTP " + e.response.status + ")";
        }
        if (!message && e && e.message) {
            message = e.message;
        }
        return message || "Sunucuya ulaşılamadı.";
    }

    /* ------------------------------------------------------------------
     * Yaşam döngüsü
     * ---------------------------------------------------------------- */

    /** Aktif şube değişince liste hemen boşaltılır ve yeniden yüklenir */
    @Watch("$store.getters.activeSiteId")
    onActiveSiteChanged() {
        if (this.activeSiteId !== null && this.loadedSiteId !== null
            && Number(this.activeSiteId) === Number(this.loadedSiteId) && !this.loading) {
            return;
        }
        this.resetForm();
        this.result = null;
        this.load();
    }

    onBeforeUnload(event: BeforeUnloadEvent) {
        // Şube değişimini kullanıcı zaten onayladıysa yenilemede ikinci kez sorulmaz
        if (this.dirty && !isLeaveConfirmed()) {
            event.preventDefault();
            event.returnValue = "";
        }
    }

    beforeRouteLeave(to: any, from: any, next: (value?: boolean) => void) {
        if (this.dirty && !window.confirm("Kaydedilmemiş değişiklikler var. Sayfadan çıkılsın mı?")) {
            next(false);
            return;
        }
        next();
    }

    created() {
        this.load();
    }

    mounted() {
        window.addEventListener("beforeunload", this.onBeforeUnload);
        // Başlıktaki şube seçici kaydedilmemiş değişiklik varken önce sorsun
        this.unsavedGuard = () => this.dirty;
        registerUnsavedGuard(this.unsavedGuard);
    }

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
        if (this.unsavedGuard) {
            unregisterUnsavedGuard(this.unsavedGuard);
            this.unsavedGuard = null;
        }
        this.releaseAllPreviews();
    }
}
